var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-form-row",class:{
    'is-disabled': _vm.disabled,
    'cell--center': _vm.isCellCenter,
    'hide-label': !_vm.isShowLabel
  }},[(_vm.isShowLabel)?_c('div',{staticClass:"v-form-row__label",style:({
      width: _vm.VFormRoot.labelWidth,
      textAlign: _vm.VFormRoot.labelPosition,
      color: _vm.VFormRoot.labelColor
    })},[_vm._t("label",function(){return [_vm._v(" "+_vm._s(_vm.label)+" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.required),expression:"required"}],staticClass:"v-form-row__required-mark"},[_vm._v("*")])]})],2):_vm._e(),_c('div',{staticClass:"v-form-row__content"},[_vm._t("default"),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showErrorMsg),expression:"showErrorMsg"}],staticClass:"v-form-row__error"},[_vm._v(" "+_vm._s(_vm.error.errorMsg)+" ")])],2),(_vm.$slots.extra)?_c('div',{staticClass:"v-form-row__extra"},[_vm._t("extra")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }